/**
 * 认证相关 API
 */
import { post, get } from '@/utils/request'
import type { UserInfo } from '@/types'

// ============================================================
// 类型
// ============================================================

/** 微信登录响应 */
export interface WechatLoginRes {
  token: string
  userInfo: UserInfo
}

/** 手机号登录请求 */
export interface PhoneLoginReq {
  phone: string
  code: string
}

// ============================================================
// API
// ============================================================

/**
 * 构造H5微信授权跳转URL
 * GET /auth/may/parent/build-auth-url
 */
export function buildAuthUrl(code: string): Promise<WechatLoginRes> {
  return get<WechatLoginRes>('/auth/may/parent/build-auth-url',
      {
        redirectUrl:code
      }
  )
}

/**
 * 微信网页授权登录
 * POST /wechat/login
 */
export function wechatLogin(code: string): Promise<WechatLoginRes> {
  return post<WechatLoginRes>('/auth/may/parent/login', { code })
}

/**
 * 手机号验证码登录（备用）
 * POST /auth/phone-login
 */
export function phoneLogin(data: PhoneLoginReq): Promise<WechatLoginRes> {
  return post<WechatLoginRes>('/auth/phone-login', data)
}

/**
 * 发送短信验证码
 * POST /auth/send-sms
 */
export function sendSms(phone: string): Promise<void> {
  return post<void>('/auth/send-sms', { phone })
}

/**
 * 刷新 Token
 * POST /auth/refresh-token
 */
export function refreshToken(): Promise<{ token: string }> {
  return post<{ token: string }>('/auth/refresh-token')
}

/**
 * 退出登录（通知后端注销 token）
 * POST /auth/logout
 */
export function logout(): Promise<void> {
  return post<void>('/auth/logout')
}
